<template>
  <div class="burton-official-dashboard">
    <header class="burton-official-dashboard__header">
      <div>
        <p class="burton-official-dashboard__eyebrow">Burton · 正式小程序</p>
        <h1>正式小程序数据看板</h1>
        <p class="burton-official-dashboard__desc">看板功能开发中，后续将按业务需求接入埋点与订单数据。</p>
      </div>
      <div class="burton-official-dashboard__actions">
        <el-button @click="router.push('/burton-dashboard')">切换看板</el-button>
        <el-button type="primary" plain @click="router.push('/')">返回工具合集</el-button>
      </div>
    </header>

    <el-empty description="正式看板需求待接入，敬请期待">
      <el-button type="primary" @click="router.push('/burton-dashboard/iap')">先查看内购看板</el-button>
    </el-empty>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router'

const router = useRouter()
</script>

<style scoped>
.burton-official-dashboard {
  min-height: 100vh;
  padding: 32px 24px 48px;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%);
}

.burton-official-dashboard__header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 48px;
  padding: 24px 28px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}

.burton-official-dashboard__eyebrow {
  margin: 0 0 6px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #0d9488;
}

.burton-official-dashboard__header h1 {
  margin: 0;
  font-size: 26px;
  color: #0f172a;
}

.burton-official-dashboard__desc {
  margin: 10px 0 0;
  font-size: 14px;
  color: #64748b;
  line-height: 1.6;
}

.burton-official-dashboard__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
</style>
